var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4859 23.315C32.4859 27.6838 28.9319 31.2379 24.563 31.2379C20.1942 31.2379 16.6415 27.6838 16.6415 23.315C16.6415 18.9462 20.1942 15.3921 24.563 15.3921C28.9319 15.3921 32.4859 18.9475 32.4859 23.315ZM49.1261 12.0649V34.5678C49.1261 37.5677 46.6938 40 43.6939 40H5.4322C2.43227 40 0 37.5677 0 34.5678V12.0649C0 9.06498 2.43227 6.63272 5.4322 6.63272H12.1138V4.75317C12.1138 2.12806 14.2405 0 16.867 0H32.2591C34.8856 0 37.0123 2.12806 37.0123 4.75317V6.63136H43.6939C46.6938 6.63272 49.1261 9.06498 49.1261 12.0649ZM36.5601 23.315C36.5601 16.6999 31.1781 11.318 24.563 11.318C17.9493 11.318 12.5674 16.6999 12.5674 23.315C12.5674 29.9301 17.9493 35.312 24.563 35.312C31.1781 35.312 36.5601 29.9301 36.5601 23.315Z",
    fill: "#D8DEE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.03a5dc702409c34e86bf774cea411421.svg";
export { ForwardRef as ReactComponent };